var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 48,
    viewBox: "0 0 113 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.795 38.097C113.273 47 106.266 47 106.266 47H4.88887C4.88887 47 -2.11575 44.0324 2.67661 34.7585C6.62125 27.125 15.9481 31.7907 15.9481 31.7907C15.9481 31.7907 14.1053 24.3714 20.3719 21.4039C26.6384 18.4363 32.5371 21.4039 32.5371 21.4039C32.5371 21.4039 34.0113 16.4049 38.8036 13.6139C43.596 10.8228 48.7573 12.5009 48.7573 12.5009C48.7573 12.5009 52.4441 0.86644 67.1895 1.00116C81.9349 1.13588 85.253 12.5009 85.253 12.5009C85.253 12.5009 92.5655 10.2752 98.8927 18.0652C104.316 24.7426 101.842 31.7907 101.842 31.7907C101.842 31.7907 110.44 29.936 111.795 38.097Z",
    fill: "white",
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/Clouds.ecf1a15f25492295dacdd95194344568.svg";
export { ForwardRef as ReactComponent };